import React, { useEffect, useState } from "react";
import { Download, X } from "lucide-react";

export default function InstallPrompt() {
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    return localStorage.getItem("presence_install_dismissed") === "1";
  });
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    const onInstalled = () => {
      setInstalled(true);
      setPrompt(null);
    };
    window.addEventListener("beforeinstallprompt", handler);
    window.addEventListener("appinstalled", onInstalled);
    // Detect standalone mode
    const mq = window.matchMedia("(display-mode: standalone)");
    if (mq.matches || window.navigator.standalone) setInstalled(true);
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
      window.removeEventListener("appinstalled", onInstalled);
    };
  }, []);

  if (installed || dismissed || !prompt) return null;

  const doInstall = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === "dismissed") {
      setDismissed(true);
      localStorage.setItem("presence_install_dismissed", "1");
    }
    setPrompt(null);
  };

  return (
    <div
      data-testid="install-banner"
      className="fixed left-3 right-3 bottom-20 md:bottom-6 md:left-auto md:right-6 md:w-[380px] z-40 border border-neutral-900 bg-white shadow-none"
    >
      <div className="p-4 flex items-start gap-3">
        <div className="w-10 h-10 bg-[#0B0F14] text-white font-heading font-black flex items-center justify-center shrink-0">1OS</div>
        <div className="flex-1 min-w-0">
          <div className="mono-label" style={{ fontSize: 10 }}>PWA</div>
          <div className="font-heading font-bold text-base tracking-tight">Install Presence for faster attendance</div>
          <p className="text-xs text-neutral-600 mt-1">
            Launches full-screen, works offline, queues safely when the signal is weak.
          </p>
          <div className="mt-3 flex gap-2">
            <button
              data-testid="btn-install"
              onClick={doInstall}
              className="h-9 px-3 bg-black text-white font-mono text-xs uppercase tracking-wider inline-flex items-center gap-2"
            >
              <Download size={14} /> Install
            </button>
            <button
              data-testid="btn-install-later"
              onClick={() => { setDismissed(true); localStorage.setItem("presence_install_dismissed", "1"); }}
              className="h-9 px-3 border border-neutral-300 font-mono text-xs uppercase tracking-wider"
            >
              Later
            </button>
          </div>
        </div>
        <button
          onClick={() => { setDismissed(true); localStorage.setItem("presence_install_dismissed", "1"); }}
          className="mono-label hover:underline"
          aria-label="close"
        >
          <X size={14} />
        </button>
      </div>
    </div>
  );
}
